import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';
import { BusinessManagment, PackageDto } from 'app/public/model/BusinessManagment';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes, Language, SourceEnum } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { BehaviorSubject, map, Observable, switchMapTo, tap } from 'rxjs';
import { BaseBusinessManagement } from './baseBusinessManagement';
import { Router } from '@angular/router';

@Component({
  selector: 'app-business-management',
  templateUrl: './business-management.component.html',
  styleUrl: './business-management.component.scss'
})
export class BusinessManagementComponent extends BaseBusinessManagement implements OnInit{
  constructor(public localizationService: LocalizationService,
             public store:Store<AppState>,
            public commonService: CommonService,
            public businessManagment:BusinessManagmentService,
             public router: Router,
) {
  super(localizationService,store,commonService,businessManagment,router)
}
ngOnInit() {
  this.init()
}

onLoadData(event) {
  this.request.Paging = event.Paging;
  this.loadBusinessRoulettes();
}


}
